import { nullable, object, string } from "../../../types/_types";

import { ArticleRef } from "../../articles/types/ArticleRef";
import { WorkRef } from "../../works/types/WorkRef";

export const CloudStartFeeMeta = object({
	article: ArticleRef,
	work: WorkRef,
	// The work's, so start fees can be filtered by language.
	language: nullable(string()).default(null),
});
